import { render, staticRenderFns } from "./YunyingData.vue?vue&type=template&id=d0c57a98&scoped=true"
import script from "./YunyingData.vue?vue&type=script&lang=js"
export * from "./YunyingData.vue?vue&type=script&lang=js"
import style0 from "./YunyingData.vue?vue&type=style&index=0&id=d0c57a98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c57a98",
  null
  
)

export default component.exports